import store from "../store/index.js";
import AppRouter from "../routes/AppRouter.jsx";
import { Provider } from "react-redux";
import "../styles/common/globals.css";

const App = () => {
  return (
    <Provider store={store}>
      <AppRouter />
    </Provider>
  );
};

export default App;
